import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

/**
 * 
 * @param {*} id 
 * 
 
 * 
 * @returns { categories, loading, error };
 */
function useSubcategories() {
  const [subcategories, setSubcategories] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const subcategories = await dataProvider.getList(
          "product-sub-categories",
          {}
        );
        setSubcategories(subcategories.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { subcategories, loading, error };
}

export default useSubcategories;
